export default __webpack_public_path__ + "static/heroimg-7096d0761ff232031f6f2cea51cee399.webp";